import React from 'react';
import { Reveal } from '../Reveal';
import { SectionHeading } from '../SectionHeading';
import { expertise, accents } from '../../data/site';
export function Expertise() {
  return <section id="expertise" className="relative scroll-mt-24 overflow-hidden bg-mist py-24 lg:py-32" data-id="element-132" data-mp="1b74utjoauf2q">
      <div className="pattern-lattice absolute inset-0 opacity-40" aria-hidden="true" data-id="element-133" data-mp="1g5oknv60kb0d" />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10" data-id="element-134" data-mp="1266qf09y85jm">
        <SectionHeading eyebrow="Areas of Expertise" title="Sixteen disciplines, one integrated legal function." description="Legal, governance, risk, and compliance capability spanning public company obligations and high-growth private enterprise." data-id="element-135" data-mp="124vl2w0uupqe" />

        <ul className="mt-16 grid gap-px overflow-hidden border border-navy/10 bg-navy/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-136" data-mp="x7lyrp8riu6s">
          {expertise.map((item, index) => {
          const accent = accents[index % accents.length];
          return <Reveal as="li" key={item.title} delay={index % 4 * 0.05} className="group relative bg-white p-7 transition-colors duration-500 hover:bg-navy" data-id="element-137" data-mp="35deilhjfh6nh" data-mpi={index}>
                <span className="eyebrow text-[0.6rem] transition-opacity duration-500" style={{
              color: accent
            }} data-id="element-138" data-mp="3f265vcdjn2s2">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-4 font-display text-lg font-normal leading-snug text-navy transition-colors duration-500 group-hover:text-white" data-id="element-139" data-mp="2hfp9c9cmwt7d">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-charcoal/65 transition-colors duration-500 group-hover:text-slate-300" data-id="element-140" data-mp="2rdwocmnd516q">
                  {item.description}
                </p>
                <span className="absolute bottom-0 left-0 h-1 w-0 transition-all duration-500 group-hover:w-full" style={{
              backgroundColor: accent
            }} data-id="element-141" data-mp="ar3u25vrflkm" />
                <span className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100" style={{
              background: `radial-gradient(75% 70% at 50% 110%, ${accent}55, transparent 70%)`
            }} aria-hidden="true" data-id="element-142" data-mp="34h8zhc28edz6" />
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}